import React, { useState } from 'react';
import emailjs from "@emailjs/browser";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs.send(
      "service_esfde0h",
      "template_i3nkbg9",
      {
        ...formData,
        type: "Contact",   //  IMPORTANT
        eventType: "",     //  pour éviter confusion
        date: ""           
      },
      "ENl3SMxqF8Dvo9m6N"
    )
    .then(() => {
      alert("Message envoyé avec succès ! 📩");

      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
      });
    })
    .catch((error) => {
      console.error(error);
      alert("Erreur lors de l'envoi ❌");
    });
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div>
      {/* Hero */}
      <section className="bg-gradient-to-r from-primary to-accent text-white section-padding">
        <div className="container-custom text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">Contactez-nous</h1>
          <p className="text-xl opacity-90">
            Une question ? Une commande spéciale ? Nous sommes à votre écoute
          </p>
        </div>
      </section>
      
      {/* Content */}
      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="grid lg:grid-cols-2 gap-12">

            {/* FORMULAIRE */}
            <div className="space-y-8">
              <div>
                <h2 className="text-3xl font-bold text-primary mb-2">Envoyez un message</h2>
              </div>
              
              <form onSubmit={handleSubmit} className="space-y-6">

                <div className="grid md:grid-cols-2 gap-6">
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Nom complet"
                    className="w-full px-4 py-3 border rounded-lg"
                  />

                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="Email"
                    className="w-full px-4 py-3 border rounded-lg"
                  />
                </div>

                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Téléphone"
                  className="w-full px-4 py-3 border rounded-lg"
                />

                <select
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border rounded-lg"
                >
                  <option value="">Sujet</option>
                  <option value="commande">Commande</option>
                  <option value="info">Information</option>
                  <option value="autre">Autre</option>
                </select>

                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="6"
                  placeholder="Votre message..."
                  className="w-full px-4 py-3 border rounded-lg"
                ></textarea>

                <button type="submit" className="btn-primary w-full py-4">
                  Envoyer le message
                </button>

              </form>
            </div>
            
            {/* INFOS CONTACT */}
            <div className="space-y-8">

              <h2 className="text-3xl font-bold text-primary">Nos coordonnées</h2>
              
              <div className="space-y-6">

                <div className="bg-gray-50 p-6 rounded-xl border-l-4 border-primary">
                  <h3 className="font-bold">Adresse</h3>
                  <p>Beyne-Heusay<br />Liège, Belgique</p>
                </div>

                <div className="bg-gray-50 p-6 rounded-xl border-l-4 border-primary">
                  <h3 className="font-bold">Téléphone</h3>
                  <p>+32 493078798</p>
                </div>

                <div className="bg-gray-50 p-6 rounded-xl border-l-4 border-primary">
                  <h3 className="font-bold">Email</h3>
                  <p>petalesdedouceur@gmail.com</p>
                </div>

              </div>

            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;